<template>
  <div ref="recommendProduct" class="swiper-j">
    <h3 v-if="showTitle" class="swiper-j_title">{{ title }}</h3>
    <div v-if="dataList.length">
      <GtSwiper
        ref="swiper"
        :key="swiperKey"
        :data="dataList.slice(0, 12) || []"
        :swiper-option="swiperOption"
      >
        <slot slot="default" slot-scope="{ data }" name="item" :data="data">
          <Item :data="data" :track-data-nav="data" :event="event" :show-final-price="false" />
        </slot>

        <!-- 分页器 -->
        <div slot="pagination">
          <div ref="nextLeft" class="swiperj-button-next">
            <i class="iconfont icon-a-24-2px-arrowright"></i>
          </div>
          <div ref="prevLeft" class="swiperj-button-prev">
            <i class="iconfont icon-a-24-2px-arrowleft"></i>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </GtSwiper>
    </div>
  </div>
</template>

<script>
import { GtSwiper, componentsCommon } from '@speedshop/template';
import { mapGetters } from 'vuex';
import ossImage from '@/mixins/ossImage';
import Item from '@/components/PLP/lpItem.vue';
export default {
  name: 'GtSwiperJ',
  components: { GtSwiper, Item },
  mixins: [componentsCommon, ossImage],
  props: {
    dataList: {
      type: Array
    },
    title: {
      type: String,
      default: '人气商品'
    },
    slidesPerView: {
      type: Number,
      default: 4
    },
    imgheight: {
      type: String,
      default: ''
    },
    target: {
      default: '_blank'
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    event: {
      type: String
    }
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: this.isMobile ? 12 : 48,
        slidesPerView: this.slidesPerView,
        slidesPerGroup: Number(this.slidesPerView),
        loop: false,
        // 设置点击箭头
        navigation: {
          nextEl: '.swiperj-button-next',
          prevEl: '.swiperj-button-prev'
        },
        on: {
          resize() {
            this.update();
            this.init();
          }
        }
      },
      swiperKey: 1,
      showButton: false
    };
  },
  computed: {
    ...mapGetters(['isMobile'])
  },
  watch: {
    dataList: {
      handler(val) {
        if (val.length) {
          val.forEach(item => {
            if (!this.isMobile) {
              item.imgUrl =
                item.mediaLink && item.mediaLink.replace(/,http/g, '[http').split('[')[0];
            } else {
              item.imgUrl =
                (item.mobileMediaLink &&
                  item.mobileMediaLink.replace(/,http/g, '[http').split('[')[0]) ||
                (item.mediaLink && item.mediaLink.replace(/,http/g, '[http').split('[')[0]);
            }
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.$eventBus.$on('updateSwiperStatus', val => {
      this.swiperKey++;
      console.log(this.swiperKey, 'this.swiperKey');
    });
  },
  methods: {
    initTrack() {
      // recommendProduct
      const ref = this.$refs.recommendProduct;
      if (!ref) return;
      const $links = ref.querySelectorAll('.recommend-link');
      $links.forEach(aTag => {
        aTag.addEventListener(
          'click',
          e => {
            const previousData = {
              source_url: this.$route.path,
              page_source: this.$route.meta.title || this.$route.name
            };
            const path = (aTag.href || '/').replace(window.location.origin, '');
            this.$trackHelp.cachePageData(path, previousData);
          },
          false
        );
      });
    }
  }
};
</script>

<style lang="scss">
.swiper-j {
  position: relative;
  margin: 0 auto;
  &_title {
    font-size: 18px;
    color: var(--main-color-ua-dark-grey, #14141e);
    font-weight: blod;
    margin-bottom: 24px;
  }
  .sp-swiper-container {
    overflow: hidden;
  }

  &_image {
    img {
      transition: transform 0.7s ease;
    }
  }
  &_image:hover {
    overflow: hidden;
    img {
      transform: scale(1.2);
    }
  }

  .swiperj-button-prev,
  .swiperj-button-next {
    width: 96px;
    border-radius: 50% !important;
    position: absolute;
    background-color: rgba(0, 0, 0, 0) !important;
    z-index: 99 !important;
    top: 0px;
    bottom: 108px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1 !important;

    cursor: pointer;
    &::after {
      color: var(--main-color-ua-dark-grey, #14141e) !important;
      font-size: 12px !important;
    }
    i {
      //  opacity: 0;
      font-size: 32px;
    }
    &.swiper-button-disabled {
      // color: #b4b4bf;
      display: none;
    }
  }
  //设计稿是48，因为icon 自带几像素的间距固改成44
  .swiperj-button-next {
    left: 100%;
    padding-left: 48px;
    justify-content: flex-start;
    &.mini {
      padding-left: 8px;
    }
  }
  .swiperj-button-prev {
    right: 100%;
    padding-right: 48px;
    justify-content: flex-end;
    &.mini {
      padding-right: 8px;
    }
  }
}
.page-layout_pc {
  @media (max-width: 1440px) {
    .swiper-j {
      .swiperj-button-next {
        padding-left: 24px;
        &.mini {
          padding-left: 8px;
        }
      }
      .swiperj-button-prev {
        padding-right: 24px;
        &.mini {
          padding-right: 8px;
        }
      }
    }
  }
}
</style>
